import React from 'react';
import ButtonWithIcon from './ButtonWithIcon';

type Props = React.ComponentProps<typeof ButtonWithIcon>;

const defaultBackground = 'var(--application-brand-dark-olive, #273e06)';
const defaultText = 'var(--application-white, #fff)';
const defaultInteractiveBackground =
  'color-mix(in srgb, white 15%, var(--color-brand-dark-olive, var(--application-brand-dark-olive, #273e06)))';

const CtaButtonWithIcon = ({
  backgroundColor = defaultBackground,
  textColor = defaultText,
  borderColor = defaultBackground,
  hoverBackgroundColor = defaultInteractiveBackground,
  activeBackgroundColor = defaultInteractiveBackground,
  ...props
}: Props) => {
  return (
    <ButtonWithIcon
      {...props}
      backgroundColor={backgroundColor}
      textColor={textColor}
      borderColor={borderColor}
      hoverBackgroundColor={hoverBackgroundColor}
      activeBackgroundColor={activeBackgroundColor}
    />
  );
};

export default CtaButtonWithIcon;
